import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { api, apiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function TakipSettingsTab() {
  const { can } = useAuth();
  const [days, setDays] = useState("");
  useEffect(() => { api.get("/takip/settings").then(({ data }) => setDays(String(data.retention_days))).catch((e) => toast.error(apiError(e))); }, []);
  const save = async (e) => {
    e.preventDefault();
    try { const { data } = await api.put("/takip/settings", { retention_days: Number(days) }); toast.success(`Saklama süresi ${data.retention_days} gün`); } catch (er) { toast.error(apiError(er)); }
  };
  return (
    <form onSubmit={save} className="panel p-4 max-w-xl space-y-3" data-testid="takip-settings-tab">
      <div className="text-sm font-semibold">Takip kayıtları saklama süresi</div>
      <p className="text-[13px] text-slate-600">Kullanıcı hareketleri bu süre dolunca otomatik silinir (30–3650 gün). Kayıtlar API ile silinemez.</p>
      <div className="flex items-center gap-2"><Input type="number" min={30} max={3650} className="w-32" value={days} onChange={(e) => setDays(e.target.value)} disabled={!can("ayarlar", "edit")} data-testid="takip-retention-input" /><span className="text-sm">gün</span>
        {can("ayarlar", "edit") && <Button type="submit" size="sm" className="bg-blue-600 hover:bg-blue-700" data-testid="takip-retention-save">Kaydet</Button>}</div>
    </form>
  );
}
